/**
 * { id: "",skuId:'',buyCount:0,price:0}
 */
const state = {
	// 购物车需要自己的状态 购物列表
	items: []
}

const getters = {
	// 返回购物车商品列表完整信息
	cartProducts: (state, getters, rootState) => {
		return state.items
	},
	// 返回所有商品总价,不管有没有选中
	totalPrice: (state, getters) => {
		let tp = 0
		if (state.items) {
			state.items.forEach(item => {
				tp += item.price * item.buyCount
			})
		}

		return tp
	},
	// 返回所有商品总数量,不管有没有选中
	totalCount: (state, getters) => {
		let t = 0
		if (!state.items) {
			return t
		}
		state.items.forEach(item => {
			t += item.buyCount
		})
		return t
	},
	// 返回所有商品条数
	totalSkuCount: (state) => {
		if (!state.items) {
			return 0
		}
		return state.items.length
	},
}

const mutations = {
	// 添加一条商品的方法
	["addCart"](state, item) {
		let cartItem = state.items.find(m => m.skuId == item.skuId)
		if (cartItem) {
			cartItem.buyCount += 1
		} else {
			let tmp = {
				...item
			}
			tmp.buyCount = 1
			state.items.unshift(tmp)
		}
	},
	// 减少一条商品中商品数量的方法
	["removeCart"](state, skuId) {
		let cartItem = state.items.find(item => item.skuId === skuId)
		if (!cartItem) {
			return
		}
		if (cartItem.buyCount > 1) { // 商品数量大于1时才能减少
			cartItem.buyCount -= 1
		} else {
			state.items.forEach((item, index) => {
				if (item.skuId === skuId) {
					state.items.splice(index, 1)
				}
			});
		}
	},
	// 清空购物车
	["clearCart"](state) {
		state.items = []
	}
}

const actions = {
	// 添加商品数量的方法
	addProductQuantity({
		commit
	}, skuData) {
		commit("addCart", skuData)
    
	},
	// 减少商品数量的方法
	delProductQuantity({
		commit
	}, id) {
		commit("removeCart", id)
	},
	clearCart({
		commit
	}) {
		commit("clearCart")
	}
}

export default {
	namespaced: true, // 添加命名空间
	state,
	getters,
	mutations,
	actions
}
